// extracted by mini-css-extract-plugin
export default {"question":"MultipleOption_question__kJD-F","answer":"MultipleOption_answer__GRRUU"};